<ul class="keyboard" *ngIf="!(shouldHideKeyboard$ | async)">
  <li class="line">
    <ul>
      <li *ngFor="let key of currentKeySet[0]" class="key letter" (click)="send(key)">{{key}}</li>      
      <li class="key backspace" (click)="deleteOne()">
          <img class="svg" src="assets/img/KeyDelete.svg" alt="icono backspace">
      </li>
    </ul>
  </li>
  <li class="line">
    <ul>
        <li *ngFor="let key of currentKeySet[1]" class="key letter" (click)="send(key)">{{key}}</li>
    </ul>
  </li>
  <li class="line">
    <ul>
        <li *ngFor="let key of currentKeySet[2]" class="key letter" (click)="send(key)">{{key}}</li>     
    </ul>
  </li>
  <li *ngIf="mails" class="line">
    <ul>
        <li *ngFor="let key of currentKeySet[3]" class="key mails" (click)="send(key)">{{key}}</li>     
    </ul>
  </li>
  <li *ngIf="mails" class="line">
    <ul>
        <li *ngFor="let key of currentKeySet[4]" class="key mails" (click)="send(key)">{{key}}</li>     
    </ul>
  </li>
  <li class="line">
    <ul>
        <li class="key shift" (click)="capsToMinusShift()" [ngStyle]="{'background-color': status === 1 ? '#2c3541' : '#8f989c' }">
            <img class="svg" src="assets/img/KeyShift.svg" alt="icono shift">
        </li>
      <li class="key numeric_switch" (click)="normalToSpecial()"> 
        <span *ngIf="status !== 2">{{"+!&\u0023\u0040"}}</span>
        <span *ngIf="status === 2">abcd</span>
      </li>
      <li class="key space" (click)="send(' ')">&nbsp;</li>
      <li class="key return">
          <img class="svg" src="assets/img/numpad-enter.svg" alt="icono enter">
      </li>
    </ul>
  </li>
</ul>